/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Step_1Inputs */

const en_mk_desktop_step_1 = /** @type {(inputs: Mk_Desktop_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extract and connect your account`)
};

const id_mk_desktop_step_1 = /** @type {(inputs: Mk_Desktop_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstrak dan hubungkan akun`)
};

/**
* | output |
* | --- |
* | "Extract and connect your account" |
*
* @param {Mk_Desktop_Step_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_step_1 = /** @type {((inputs?: Mk_Desktop_Step_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Step_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_step_1(inputs)
	return en_mk_desktop_step_1(inputs)
});